import React from "react"
import { Grid2 } from "@mui/material"

import { HeaderProps } from "@/components/Dialog/protocols"

export const Header = ({ children }: HeaderProps) => {
	return (
		<Grid2 size={12}>
			<Grid2
				container
				justifyContent="space-between"
				alignItems="center"
				height="100%"
			>
				{children}
			</Grid2>
		</Grid2>
	)
}
